import styled from 'styled-components';
import theme from '../theme';
import fn from '../../helpers/fn';

export default fn(__filename, styled.div`
  line-height: 1.5;
  margin: 0 0 ${theme.unit * 2}px;
  color: ${theme.colors.gray3};

  &:last-child {
    margin-bottom: 0;
  }

  ${({ white }) => white && `
    color: white;
  `};
`);



// WEBPACK FOOTER //
// ./src/components/text/Text.js